import React from 'react'

import ReportSegment from '../../generic/report-segment'
import Report from '../../../utility/report-service'
import { faExternalLinkAlt, faUnlink } from '@fortawesome/free-solid-svg-icons'

function LinkChecker() {
  return (
    <section className="link-checker">
      <div className="container">
        <h2 id="link-checker">Link Checker</h2>
        <div className="row halves">
          <ReportSegment
            title="Internal Broken Links"
            subtitle="Bottom text"
            data={Report.linkChecker.internalBrokenLinks}
            icon={faUnlink}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="External Broken Links"
            subtitle="Bottom text"
            data={Report.linkChecker.externalBrokenLinks}
            icon={faExternalLinkAlt}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Internal Redirect Links"
            subtitle="Bottom text"
            data={Report.linkChecker.internalRedirects}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="External Redirect Links"
            subtitle="Bottom text"
            data={Report.linkChecker.externalRedirects}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
        </div>
      </div>
    </section>
  )
}

export default LinkChecker
